import Header from "../components/Header";
import Leaderboard from "../components/Leaderboard";
import styled from "styled-components";

const Container = styled.div`
    color: white;
    font-family: 'Inter', sans-serif;
    text-align: left;
    max-width: 800px;
    margin: 0 auto;
    
    line-height: 2;
    
    li {
        margin-bottom: 10px;
    }
    
    ol {
        margin-top: 10px;
    }

    h2 {
        text-transform: uppercase;
        color: #d2a83a;
        font-size: 32pt;
        text-align: center;
    }
`;

export default function Rules() {
    return (
        <>
            <Header />

            <Container>
                <h2>Rules</h2>
                <ol>
                    <li>
                        Be respectful when sniping.
                    </li>
                    <li>
                        Navigators events, official and unofficial, and the Study Table are safe. This includes Nav
                        Night, ROOTS/LEAF/OAKS, miscellaneous/holiday events, Pirate House dinners, and discipleship
                        meetings.
                    </li>
                    <li>
                        The goal of sniping is the unawareness of the victim. If your target is aware of your presence,
                        you cannot snipe them, including if:
                        <ol>
                            <li>
                                You share a class together; or
                            </li>
                            <li>
                                They are waiting to meet with you.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Discipleship meetings are completely safe. Participants in an active discipleship meeting are
                        not allowed to snipe, nor may they be sniped.
                    </li>
                    <li>
                        You are not allowed to snipe the same person (or group) more than once while they remain in the
                        same position, regardless of elapsed time since the previous snipe.
                    </li>
                </ol>
            </Container>
        </>
    );
}